import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';

export default function useBusinesses() {
  return useSelector((state: RootState) => state.application.businesses);
}
